module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "id": "logo"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-autocomplete', {
    attrs: {
      "popper-class": "gsh-autocomplete",
      "fetch-suggestions": _vm.querySearchAsync,
      "custom-item": "gsh-item-zh",
      "placeholder": "作品名称或作者姓名",
      "size": "large",
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b441a3be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 192
// module chunks = 1